import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Select from "react-select";
// import { Check } from "feather-icons-react/build/IconComponents";
import PosModals from "../../core/modals/pos-modal/posModals";
import { fetchProductList, getProductById } from "../../api/productApi";
import { getAllCategories } from "../../api/categoryApi";
import PropTypes from "prop-types";
import axios from "axios";
// import { isDemoActive } from "../../api/client";
import { mockPos } from "../../api/mock/pos";
import ImageWithBasePath from "../../core/img/imagewithbasebath";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// --- image URL helpers ---
const isHttpUrl = (v) => typeof v === "string" && /^https?:\/\//i.test(v);
const looksLikeCatalog = (v) =>
  typeof v === "string" && /^\/?(catalog|catelog)\//i.test(v);
const normalizeKey = (s = "") => {
  let v = String(s)
    .trim()
    .replace(/^\/+/, "")
    .replace(/^catelog\//i, "catalog/");
  if (!/^catalog\//i.test(v)) v = `catalog/${v.split("/").pop()}`;
  return v;
};
const toPublicUrl = (v) => {
  if (!v) return "";
  if (isHttpUrl(v)) return v; // already a full URL
  if (looksLikeCatalog(v)) {
    const base = (
      process.env.REACT_APP_API_IMAGE_BASE_URL ||
      "https://hamilton-shop-images.s3.ap-south-1.amazonaws.com"
    ).replace(/\/+$/, "");
    return `${base}/${normalizeKey(v)}`;
  }
  return v; // leave plain filenames (used for local assets) as-is
};

//Helper to detect "no store" 403 errors
const noStore403 = (err) => {
  const msg = err?.response?.data?.message || err?.message || "";
  const code = err?.response?.status;
  return (
    code === 403 && /no\s*store/i.test(msg) // matches "No storeId on user; access denied"
  );
};

const Pos = () => {
  const [activeTab, setActiveTab] = useState("all");
  //   const [showAlert, setShowAlert] = useState(true);
  const [demo, setDemo] = useState(false);

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [productCache, setProductCache] = useState({});

  const [receivedAmount, setReceivedAmount] = useState("");
  const [payingAmount, setPayingAmount] = useState(0);
  const [change, setChange] = useState(0);
  const [paymentType, setPaymentType] = useState({
    value: "cash",
    label: "Cash",
  });

  const [paymentReceiver, setPaymentReceiver] = useState("");
  const [paymentNote, setPaymentNote] = useState("");
  const [saleNote, setSaleNote] = useState("");
  const [staffNote, setStaffNote] = useState("");

  const [lastTransaction, setLastTransaction] = useState(null);
  const [invoiceLang, setInvoiceLang] = useState("en"); // "en" | "ar"

  const labels = {
    en: {
      invoice: "Invoice",
      orderId: "Order ID",
      date: "Date",
      paymentType: "Payment Type",
      cashier: "Payment Receiver",
      items: "Items",
      qty: "Qty",
      price: "Price",
      lineTotal: "Total",
      subtotal: "Subtotal",
      total: "Total",
      received: "Received",
      paying: "Paying",
      change: "Change",
      thankYou: "Thank you for your purchase!",
    },
    ar: {
      invoice: "فاتورة",
      orderId: "رقم الطلب",
      date: "التاريخ",
      paymentType: "طريقة الدفع",
      cashier: "المستلم",
      items: "العناصر",
      qty: "الكمية",
      price: "السعر",
      lineTotal: "الإجمالي",
      subtotal: "الإجمالي الفرعي",
      total: "الإجمالي",
      received: "المبلغ المستلم",
      paying: "المبلغ المدفوع",
      change: "الباقي",
      thankYou: "شكراً لتسوقكم!",
    },
  };

  const nf = (n, lang) =>
    (typeof n === "number" ? n : Number(n || 0)).toLocaleString(
      lang === "ar" ? "ar-SA" : "en-US",
      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    );

  const buildInvoiceHtml = (tx, lang = "en") => {
    const L = labels[lang] || labels.en;
    const dir = lang === "ar" ? "rtl" : "ltr";
    const alignStart = lang === "ar" ? "right" : "left";
    const alignEnd = lang === "ar" ? "left" : "right";

    // Subtotal from items (price * quantity)
    const subtotal2 = (tx.items || []).reduce(
      (sum, it) => sum + Number(it.price || 0) * Number(it.quantity || 0),
      0
    );

    // Fallbacks from tx
    const total =
      typeof tx.totalAmount === "number" ? tx.totalAmount : subtotal2;
    const received = tx.receivedAmount ?? 0;
    const paying = tx.payingAmount ?? total;
    const changeVal = tx.change ?? Math.max(0, received - paying);

    const todayStr = new Date(tx.createdAt || Date.now()).toLocaleString(
      lang === "ar" ? "ar-SA" : "en-US"
    );

    const rows = (tx.items || [])
      .map(
        (it) => `
      <tr>
        <td>${it.name || ""}</td>
        <td style="text-align:center">${nf(it.quantity || 0, lang)}</td>
        <td style="text-align:${alignEnd}">${nf(it.price || 0, lang)}</td>
        <td style="text-align:${alignEnd}">${nf(
          (it.price || 0) * (it.quantity || 0),
          lang
        )}</td>
      </tr>`
      )
      .join("");

    return `
<!DOCTYPE html>
<html lang="${lang}" dir="${dir}">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width,initial-scale=1" />
<title>${L.invoice}</title>
<style>
  body { font-family: Arial, sans-serif; margin: 0; padding: 16px; }
  .wrap { max-width: 360px; margin: 0 auto; }
  h1 { font-size: 18px; margin: 0 0 8px; text-align: center; }
  .meta { font-size: 12px; margin-bottom: 12px; }
  .meta div { display: flex; justify-content: space-between; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; }
  th, td { padding: 6px 4px; border-bottom: 1px dashed #ddd; }
  th { text-align: ${alignStart}; font-weight: bold; background: #f8f8f8; }
  tfoot td { border: 0; padding: 4px 4px; }
  .total-row td { border-top: 1px solid #000; font-weight: bold; }
  .thanks { text-align: center; margin-top: 12px; font-size: 12px; }
  .end { text-align: ${alignEnd}; }
  .start { text-align: ${alignStart}; }
</style>
</head>
<body>
  <div class="wrap">
    <h1>${L.invoice} / ${lang === "ar" ? "Invoice" : "فاتورة"}</h1>

    <div class="meta">
      <div><span>${L.orderId}</span><strong>${tx.orderId || "-"}</strong></div>
      <div><span>${L.date}</span><strong>${todayStr}</strong></div>
      <div><span>${L.paymentType}</span><strong>${tx.type || "-"}</strong></div>
      <div><span>${L.cashier}</span><strong>${
      tx.paymentReceiver || "-"
    }</strong></div>
    </div>

    <table>
      <thead>
        <tr>
          <th class="start">${L.items}</th>
          <th style="text-align:center">${L.qty}</th>
          <th class="end">${L.price}</th>
          <th class="end">${L.lineTotal}</th>
        </tr>
      </thead>
      <tbody>
        ${rows || `<tr><td colspan="4" style="text-align:center">—</td></tr>`}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3" class="end">${L.subtotal}</td>
          <td class="end">${nf(subtotal2, lang)}</td>
        </tr>
        <tr class="total-row">
          <td colspan="3" class="end">${L.total}</td>
          <td class="end">${nf(total, lang)}</td>
        </tr>
        <tr>
          <td colspan="3" class="end">${L.received}</td>
          <td class="end">${nf(received, lang)}</td>
        </tr>
        <tr>
          <td colspan="3" class="end">${L.paying}</td>
          <td class="end">${nf(paying, lang)}</td>
        </tr>
        <tr>
          <td colspan="3" class="end">${L.change}</td>
          <td class="end">${nf(changeVal, lang)}</td>
        </tr>
      </tfoot>
    </table>

    <div class="thanks">${L.thankYou}</div>
  </div>

  <script>
    window.onload = function () {
      window.print();
      setTimeout(() => window.close(), 300);
    };
  </script>
</body>
</html>
`;
  };

  const printInvoice = (lang = invoiceLang, tx = lastTransaction) => {
    if (!tx) {
      alert(
        window.translate(
          "No completed transaction to print. Please place an order first."
        )
      );
      return;
    }
    const w = window.open("", "_blank", "width=420,height=600");
    if (!w) {
      alert(
        window.translate(
          "Popup blocked. Please allow popups to print the invoice."
        )
      );
      return;
    }
    w.document.open();
    w.document.write(buildInvoiceHtml(tx, lang));
    w.document.close();
  };

  // Fetch the categories
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const categoryData = await getAllCategories(); // try live first
        const normalized = categoryData.map((cat) => {
          const raw = cat.image || "category-default.svg";
          const isLocalAsset =
            !/^data:image/i.test(raw) &&
            !isHttpUrl(raw) &&
            !looksLikeCatalog(raw);
          const imageUrl = /^data:image/i.test(raw)
            ? raw
            : isLocalAsset
            ? `assets/img/categories/${raw}`
            : toPublicUrl(raw);
          return {
            _id: String(cat._id || cat.id || cat.CategoryId)
              .trim()
              .toLowerCase(),
            name: cat.name || cat.CategoryName || "Unnamed",
            imageUrl, // ready to render
            isLocalAsset, // tells render which component to use
          };
        });
        setCategories([
          {
            _id: "all",
            name: `${window.translate("All")}`,
            imageUrl: "assets/img/categories/category-01.svg",
            isLocalAsset: true,
          },
          ...normalized,
        ]);
        setDemo(false); // we’re live
      } catch (e) {
        if (!noStore403(e)) {
          console.error("Failed to fetch categories:", e);
          return;
        }
        // 403 because store id is missing -> demo fallback
        setDemo(true);
        const normalized = mockPos.categories.map((cat) => {
          const raw = cat.image || "category-default.svg";
          const isLocalAsset =
            !/^data:image/i.test(raw) &&
            !isHttpUrl(raw) &&
            !looksLikeCatalog(raw);
          const imageUrl = /^data:image/i.test(raw)
            ? raw
            : isLocalAsset
            ? `assets/img/categories/${raw}`
            : toPublicUrl(raw);
          return {
            _id: String(cat.id).trim().toLowerCase(),
            name: cat.name,
            imageUrl,
            isLocalAsset,
          };
        });
        setCategories([
          {
            _id: "all",
            name: `${window.translate("All")}`,
            imageUrl: "assets/img/categories/category-01.svg",
            isLocalAsset: true,
          },
          ...normalized,
        ]);
      }
    };
    loadCategories();
  }, []);

  // fetch the product
  useEffect(() => {
    const loadProducts = async () => {
      try {
        // -     const storeId = localStorage.getItem("storeId") || localStorage.getItem("store_id");
        // -     if (demo || !storeId) throw new Error("demo-or-no-store");
        // -
        const result = await fetchProductList(); // live call
        const categoryData = await getAllCategories(); // live call
        const categoryMap = {};
        categoryData.forEach((cat) => {
          const name = (cat.name || cat.CategoryName || "")
            .toLowerCase()
            .trim();
          const id = String(cat._id || cat.id || cat.CategoryId).trim();
          categoryMap[name] = id;
        });
        const normalizedProducts = result.flatMap((p) => {
          const baseProduct = {
            ...p,
            CategoryId: (() => {
              const rawCategory =
                typeof p.Category === "object"
                  ? p.Category.name || p.Category.CategoryName
                  : p.Category;
              const categoryName = String(rawCategory || "")
                .toLowerCase()
                .trim();
              return categoryMap[categoryName] || "uncategorized";
            })(),
            _id: p._id || p.id || p.ProductId,
            quantity: 1,
            Price: Number(p.Price ?? p.price ?? 0),
            Qty: Number(p.Qty ?? p.quantity ?? 0),
          };
          if (Array.isArray(p.variantItems) && p.variantItems.length > 0) {
            return [
              {
                ...baseProduct,
                allVariants: p.variantItems.map((v) => ({
                  ...baseProduct,
                  baseProductId: baseProduct._id,
                  _id: v._id,
                  variantId: v._id,
                  name: v.name,
                  Product_Name: `${p.Product_Name} - ${v.name}`,
                  Price: Number(v.price ?? 0),
                  Qty: Number(v.quantity ?? 0),
                  tax: v.tax,
                  discountValue: v.discountValue,
                  discountType: v.discountType,
                  taxType: v.taxType,
                  image: v.image || baseProduct.image,
                  isVariant: true,
                  attributes: `${p.variantAttributes?.join(", ")}: ${v.name}`,
                })),
                isParent: true,
              },
            ];
          }
          return [baseProduct];
        });
        setProducts(normalizedProducts);
        setDemo(false); // we’re live
      } catch (e) {
        // -     if (e.message === "demo-or-no-store" || isDemoActive() || noStore403(e)) {
        if (noStore403(e)) {
          setDemo(true);
          const categoryMap = {};
          mockPos.categories.forEach((c) => {
            categoryMap[c.name.toLowerCase()] = c.id;
          });
          const normalizedProducts = mockPos.products.map((p) => ({
            ...p,
            _id: p._id || p.id,
            CategoryId:
              categoryMap[String(p.Category || "").toLowerCase()] ||
              "uncategorized",
            Price: Number(p.Price ?? p.price ?? 0),
            Qty: Number(p.Qty ?? p.quantity ?? 0),
            quantity: 1,
          }));
          setProducts(normalizedProducts);
          return;
        }
        console.error("Failed to load products:", e);
      }
    };
    loadProducts();
  }, []);

  const filteredProducts =
    activeTab === "all"
      ? products
      : products.filter((p) => p.CategoryId === activeTab);

  useEffect(() => {
    console.log(`📁 ActiveTab: ${activeTab}`);
    console.log("📦 Filtered Products:", filteredProducts);
  }, [activeTab, products]);

  // const handleProductClick = async (product) => {
  //   const productId = String(product._id || product.id);

  //   // If already in selectedItems, do nothing
  //   const alreadyExists = selectedItems.find(
  //     (item) => String(item._id) === productId
  //   );
  //   if (alreadyExists) {
  //     console.log(`✔️ Product already in cart: ${alreadyExists.Product_Name}`);
  //     return;
  //   }

  //   try {
  //     let detailedProduct = productCache[productId];

  //     if (!detailedProduct) {
  //       detailedProduct = await getProductById(productId);
  //       setProductCache((prev) => ({
  //         ...prev,
  //         [productId]: detailedProduct,
  //       }));
  //     }

  //     const enriched = {
  //       ...product,
  //       ...detailedProduct,
  //       _id: productId,
  //       Product_Name: detailedProduct.name || product.name || "Unnamed",
  //       Price: detailedProduct.price || product.price || 0,
  //       quantity: 1, // ✅ Force quantity 2 on initial add
  //     };
  //     console.log(
  //       `🛒 Added new item: ${enriched.Product_Name} | Qty: 1 × $${enriched.Price} = $${enriched.Price}`
  //     );
  //     setSelectedItems((prevItems) => [...prevItems, enriched]);
  //   } catch (error) {
  //     console.error("Failed to fetch product details:", error);
  //   }
  // };

  const handleProductClick = async (product) => {
    const productId = String(product._id || product.id);
    const alreadyExists = selectedItems.find(
      (item) => String(item._id) === productId
    );
    if (alreadyExists) return;

    try {
      let detailedProduct = productCache[productId];

      if (!detailedProduct) {
        if (demo) {
          // in demo, just use the product we have
          detailedProduct = product;
        } else {
          detailedProduct = await getProductById(productId);
          detailedProduct = detailedProduct?.data || detailedProduct;
        }
        setProductCache((prev) => ({ ...prev, [productId]: detailedProduct }));
      }

      const enriched = {
        ...product,
        _id: productId,
        Product_Name:
          detailedProduct.name ||
          product.Product_Name ||
          product.name ||
          "Unnamed",
        Price: Number(detailedProduct.price ?? product.Price ?? 0),
        quantity: 1,
        stockQty: Number(detailedProduct.quantity ?? product.Qty ?? Infinity),
        isVariant: Boolean(detailedProduct.isVariant ?? product.isVariant),
      };

      if (!demo && enriched.stockQty <= 0) {
        alert("This item is out of stock.");
        return;
      }

      setSelectedItems((prev) => [...prev, enriched]);
    } catch (error) {
      // if (noStore403(error) || isDemoActive()) {
      if (noStore403(error)) {
        setDemo(true);
        setSelectedItems((prev) => [
          ...prev,
          {
            ...product,
            _id: productId,
            Product_Name: product.Product_Name || product.name || "Unnamed",
            Price: Number(product.Price ?? 0),
            quantity: 1,
            stockQty: Number(product.Qty ?? Infinity),
          },
        ]);
        return;
      }
      console.error("Failed to fetch product details:", error);
    }
  };

  // const handleQuantityChange = (id, newQty) => {
  //   const idStr = String(id);

  //   setSelectedItems((prev) => {
  //     const exists = prev.find((item) => String(item._id) === idStr);
  //     if (newQty <= 0) {
  //       console.log(`🗑 Removed product with ID: ${idStr}`);
  //       return prev.filter((item) => String(item._id) !== idStr);
  //     }
  //     if (exists) {
  //       console.log(
  //         `📝 Updated quantity for ${exists.Product_Name || exists.name}:`,
  //         newQty,
  //         "× $",
  //         exists.Price,
  //         "= $",
  //         (newQty * exists.Price).toFixed(2)
  //       );
  //       return prev.map((item) =>
  //         String(item._id) === idStr ? { ...item, quantity: newQty } : item
  //       );
  //     }
  //     return prev;
  //   });
  // };

  const handleQuantityChange = (id, newQty) => {
    const idStr = String(id);

    setSelectedItems((prev) => {
      const exists = prev.find((item) => String(item._id) === idStr);
      if (!exists) return prev;

      if (newQty <= 0) {
        return prev.filter((i) => String(i._id) !== idStr);
      }

      const max = Number(exists.stockQty ?? Infinity);
      if (newQty > max) {
        alert(`Only ${max} left in stock for "${exists.Product_Name}".`);
        newQty = max;
      }

      return prev.map((item) =>
        String(item._id) === idStr ? { ...item, quantity: newQty } : item
      );
    });
  };

  useEffect(() => {
    console.log("🛒 Updated selectedItems:", selectedItems);
  }, [selectedItems]);

  const handleRemoveItem = (id) => {
    const idStr = String(id);

    setSelectedItems((prev) => {
      // Filter out the item being removed
      const newSelectedItems = prev.filter(
        (item) => String(item._id) !== idStr
      );

      // If no items left after removal, reset the cart message
      if (newSelectedItems.length === 0) {
        console.log("🛒 Cart is empty!");
      }

      return newSelectedItems;
    });

    // Reset the quantity of the removed product in the products list
    setProducts((prev) =>
      prev.map((item) =>
        String(item._id) === idStr ? { ...item, quantity: 0 } : item
      )
    );

    // Ensure that the count reflects the actual number of items in the cart
    // console.log("Updated Order Details:", newSelectedItems.length);
  };

  // tax details
  const subtotal = selectedItems.reduce(
    (sum, item) => sum + item.Price * item.quantity,
    0
  );
  //   shipping
  const shipping = 0;

  //   tax
  const tax = selectedItems.reduce((sum, item) => {
    const taxVal = parseFloat(item.taxType) || 0;
    return sum + (taxVal / 100) * item.Price * item.quantity;
  }, 0);

  //   coupan
  const coupon = 0;

  //   discount
  const discount = selectedItems.reduce((sum, item) => {
    const discountVal = parseFloat(item.discountValue) || 0;
    return sum + (discountVal / 100) * item.Price * item.quantity;
  }, 0);

  // roundoff
  const roundoff = 0.11;

  const totalPayable = subtotal + shipping + tax - coupon - discount + roundoff;

  //   Quantity change handler for CartCounter
  const QuantityCounter = ({ value, onChange, max = Infinity }) => {
    const handleDecrement = () => {
      if (value > 1) onChange(value - 1);
    };
    const handleIncrement = () => {
      if (value < max) onChange(value + 1);
    };
    const atMax = value >= max;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ccc",
          borderRadius: "30px",
          overflow: "hidden",
          height: "36px",
          width: "100px",
          backgroundColor: "#fff",
        }}
        onClick={(e) => e.stopPropagation()} // prevent product card click
      >
        <button
          onClick={handleDecrement}
          style={{
            width: "32px",
            height: "100%",
            border: "none",
            backgroundColor: "#f0f0f0",
            fontSize: "18px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          −
        </button>
        <div
          style={{
            flex: 1,
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "500",
            userSelect: "none",
          }}
        >
          {value}
        </div>
        <button
          onClick={handleIncrement}
          disabled={atMax}
          title={atMax ? "No more stock" : ""}
          style={{
            width: "32px",
            height: "100%",
            border: "none",
            backgroundColor: "#f0f0f0",
            fontSize: "18px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          +
        </button>
      </div>
    );
  };

  // ✅ Add prop type validation
  QuantityCounter.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    max: PropTypes.number,
  };

  // Handle Place Order submission
  // Calculate change when receivedAmount or payingAmount changes
  useEffect(() => {
    const r = parseFloat(receivedAmount) || 0;
    const p = parseFloat(payingAmount) || 0;
    setChange(r - p > 0 ? r - p : 0);
  }, [receivedAmount, payingAmount]);

  // Handle Place Order submission
  const handlePlaceOrder = async () => {
    try {
      const token = localStorage.getItem("token"); // or wherever you store it
      const storeId = localStorage.getItem("storeId"); // if you use multi-tenant header
      if (!Array.isArray(selectedItems) || selectedItems.length === 0) {
        alert("No items selected.");
        return;
      }

      const validItems = selectedItems.filter(
        (item) => item && item._id && item.quantity > 0
      );

      if (validItems.length === 0) {
        alert("No valid items to process.");
        return;
      }

      const payload = {
        orderId: `ORD-${Date.now()}`,
        type: paymentType?.value || "cash",
        receivedAmount: parseFloat(receivedAmount),
        payingAmount: parseFloat(payingAmount),
        change: parseFloat(change),
        paymentReceiver,
        paymentNote,
        saleNote,
        staffNote,
        // customerId,
        totalAmount: parseFloat(totalPayable),
        items: validItems.map((item) => ({
          productId: item._id,
          variantId: item.isVariant ? item._id : undefined,
          name: item.Product_Name || item.name || "Unnamed",
          warehouse:
            item.warehouse || item.Warehouse || item.details?.warehouse,
          quantity: item.quantity,
          price: item.Price,
        })),
      };

      const res = await axios.post(
        `${API_BASE_URL}api/transactions/`,
        payload,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "X-Store-Id": storeId || undefined, // only if your backend expects it
          },
          withCredentials: true, // if you also support cookie tokens
        }
      );

      if (res.data.success) {
        const tx = res.data.transaction;
        setLastTransaction(tx);
        alert(window.translate("✅ Transaction created successfully!"));
        // Reset cart and forms
        setSelectedItems([]);
        setReceivedAmount("");
        setPayingAmount(0);
        setChange(0);
        setPaymentReceiver("");
        setPaymentNote("");
        setSaleNote("");
        setStaffNote("");
        setPaymentType({ value: "cash", label: "Cash" });
      }
    } catch (err) {
      console.error("❌ Transaction Error:", err);
      alert("Failed to submit transaction.");
    }
  };

  // Render product card
  const renderProductCard = (product) => {
    const isSelected = selectedItems.some(
      (item) => String(item._id) === String(product._id)
    );

    return (
      <div
        key={product._id}
        className="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3"
      >
        <div
          className={`product-info card mb-0 ${isSelected ? "active" : ""}`}
          data-product-id={product._id}
          onClick={() => handleProductClick(product)}
          tabIndex="0"
        >
          <Link to="#" className="pro-img">
            <img
              src={product.image}
              style={{ width: "160px", height: "160px", objectFit: "cover" }}
              alt={product.Product_Name}
              onError={(e) => (e.target.src = "/assets/img/products/shoes.jpg")}
            />
            <span>
              <i className="ti ti-circle-check-filled" />
            </span>
          </Link>

          <h6 className="cat-name">
            <Link to="#">{product.Category || "Uncategorized"}</Link>
          </h6>

          <h6 className="product-name">
            <Link to="#">
              {product.Product_Name || product.name}
              {/* {product.isVariant && product.attributes ? (
                <small
                  style={{ display: "block", fontSize: "12px", color: "#888" }}
                >
                  {product.attributes}
                </small>
              ) : null} */}
            </Link>
          </h6>

          {product.allVariants?.length > 0 && (
            <div className="variant-buttons d-flex flex-wrap gap-1 mb-2 px-2">
              {product.allVariants.map((variant) => {
                const isSelected = selectedItems.some(
                  (item) => String(item._id) === String(variant._id)
                );

                return (
                  <button
                    key={variant._id}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleProductClick(variant);
                    }}
                    className={`btn btn-sm px-3 py-1 ${
                      isSelected
                        ? "btn-primary text-white"
                        : "btn-outline-secondary"
                    }`}
                    style={{
                      borderRadius: "20px",
                      fontSize: "12px",
                      textTransform: "capitalize",
                    }}
                  >
                    {variant.name}
                  </button>
                );
              })}
            </div>
          )}

          <div className="d-flex align-items-center justify-content-between price px-2">
            <p className="text-gray-9 mb-0">
              {Number(product.Price || 0).toFixed(2)}
            </p>
            <div className="qty-item m-0">
              {/* <QuantityCounter
                value={
                  selectedItems.find(
                    (item) => String(item._id) === String(product._id)
                  )?.quantity ?? 1
                }
                onChange={(newQty) => handleQuantityChange(product._id, newQty)}
              /> */}
              <QuantityCounter
                value={
                  selectedItems.find(
                    (item) => String(item._id) === String(product._id)
                  )?.quantity ?? 1
                }
                max={
                  selectedItems.find(
                    (item) => String(item._id) === String(product._id)
                  )?.stockQty ?? Infinity
                }
                onChange={(newQty) => handleQuantityChange(product._id, newQty)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="main-wrapper pos-five">
      <div className="page-wrapper pos-pg-wrapper me-0 ms-0">
        <div className="content pos-design p-0">
          <div className="row pos-wrapper">
            {/* Products */}
            <div className="col-md-12 col-lg-7 col-xl-8 d-flex">
              <div className="pos-categories tabs_wrapper p-0 flex-fill">
                <div className="content-wrap">
                  <div className="tab-wrap">
                    <ul className="tabs owl-carousel pos-category5">
                      {categories.map((cat) => (
                        <li
                          key={cat._id}
                          onClick={() => {
                            console.log(`🟡 Category Selected: ${cat._id}`);
                            setActiveTab(cat._id);
                          }}
                          className={activeTab === cat._id ? "active" : ""}
                        >
                          <Link to="#">
                            {cat.isLocalAsset ? (
                              <ImageWithBasePath
                                src={cat.imageUrl} // e.g. assets/img/categories/category-01.svg
                                alt="Category"
                              />
                            ) : (
                              <img
                                src={cat.imageUrl} // S3/http(s)/data URL
                                alt="Category"
                                onError={(e) =>
                                  (e.currentTarget.src =
                                    "/assets/img/categories/default.svg")
                                }
                              />
                            )}
                          </Link>
                          <h6>
                            <Link to="#">{cat.name}</Link>
                          </h6>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="tab-content-wrap">
                    <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                      <div className="mb-3">
                        <h5 className="mb-1">{window.translate("Welcome")}</h5>
                        <p>
                          {new Date().toLocaleDateString("en-US", {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                          })}
                        </p>
                      </div>
                      {/* <div className="d-flex align-items-center flex-wrap mb-2">
                        <div className="input-icon-start search-pos position-relative mb-2 me-3">
                          <span className="input-icon-addon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search Product"
                          />
                        </div>
                        <Link to="#" className="btn btn-sm btn-dark mb-2 me-2">
                          <i className="ti ti-tag me-1" />
                          View All Brands
                        </Link>
                        <Link to="#" className="btn btn-sm btn-primary mb-2">
                          <i className="ti ti-star me-1" />
                          Featured
                        </Link>
                      </div> */}
                    </div>
                    <div className="pos-products">
                      <div className="tabs_container">
                        <div
                          className={`tab_content ${activeTab} active`}
                          data-tab={activeTab}
                        >
                          <div className="row g-3">
                            {filteredProducts.length > 0 ? (
                              filteredProducts.map(renderProductCard)
                            ) : (
                              <div className="col-12">
                                <p className="text-muted fs-3">
                                  {window.translate(
                                    "No products found in this category"
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Products */}

            {/* Order Details */}
            <div className="col-md-12 col-lg-5 col-xl-4 ps-0 theiaStickySidebar d-lg-flex">
              <aside className="product-order-list bg-secondary-transparent flex-fill">
                <div className="card">
                  <div className="card-body">
                    <div className="order-head d-flex align-items-center justify-content-between w-100">
                      <div>
                        <h3>{window.translate("Order List")}</h3>
                      </div>
                      {/* <div className="d-flex align-items-center gap-2">
                        <span className="badge badge-dark fs-10 fw-medium badge-xs">
                          #ORD123
                        </span>
                        <Link className="link-danger fs-16" to="#">
                          <i className="ti ti-trash-x-filled" />
                        </Link>
                      </div> */}
                    </div>
                    {/* <div className="customer-info block-section">
                      <h5 className="mb-2">Customer Information</h5>
                      <div className="d-flex align-items-center gap-2">
                        <div className="flex-grow-1">
                          <Select
                            options={options}
                            classNamePrefix="react-select select"
                            placeholder="Choose a Name"
                            defaultValue={options[0]}
                            onChange={(selected) =>
                              setCustomerId(selected?.value)
                            }
                          />
                        </div>
                        <Link
                          to="#"
                          className="btn btn-teal btn-icon fs-20"
                          data-bs-toggle="modal"
                          data-bs-target="#create"
                        >
                          <i className="ti ti-user-plus" />
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-info btn-icon fs-20"
                          data-bs-toggle="modal"
                          data-bs-target="#barcode"
                        >
                          <i className="ti ti-scan" />
                        </Link>
                      </div>
                      {showAlert && (
                        <div className="customer-item border border-orange bg-orange-100 d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
                          <div>
                            <h6 className="fs-16 fw-bold mb-1">
                              James Anderson
                            </h6>
                            <div className="d-inline-flex align-items-center gap-2 customer-bonus">
                              <p className="fs-13 d-inline-flex align-items-center gap-1">
                                Bonus :
                                <span className="badge bg-cyan fs-13 fw-bold p-1">
                                  148
                                </span>{" "}
                              </p>
                              <p className="fs-13 d-inline-flex align-items-center gap-1">
                                Loyality :
                                <span className="badge bg-teal fs-13 fw-bold p-1">
                                  $20
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                          <Link to="#" className="btn btn-orange btn-sm">
                            Apply
                          </Link>
                          <Link
                            to="#"
                            className="close-icon"
                            onClick={() => setShowAlert(false)}
                          >
                            <i className="ti ti-x" />
                          </Link>
                        </div>
                      )}
                    </div> */}
                    <div className="product-added block-section">
                      <div className="head-text d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2">
                          <h5 className="me-2">
                            {window.translate("Order Details")}
                          </h5>
                          <div className="badge bg-light text-gray-9 fs-12 fw-semibold py-2 border rounded">
                            {window.translate("Items")} :{" "}
                            <span className="text-teal">
                              {selectedItems.length}
                            </span>
                          </div>
                        </div>
                        {/* <Link
                          to="#"
                          className="d-flex align-items-center clear-icon fs-10 fw-medium"
                        >
                          Clear all
                        </Link> */}
                      </div>
                      <div className="product-wrap">
                        <div className="empty-cart">
                          <div className="fs-24 mb-1">
                            <i className="ti ti-shopping-cart" />
                          </div>
                          <p className="fw-bold">
                            {window.translate("No Products Selected")}
                          </p>
                        </div>
                        <div className="product-list border-0 p-0">
                          <div className="table-responsive">
                            <table className="table table-borderless">
                              <thead>
                                <tr>
                                  <th className="fw-bold bg-light">
                                    {window.translate("Item")}
                                  </th>
                                  <th className="fw-bold bg-light">
                                    {window.translate("QTY")}
                                  </th>
                                  <th className="fw-bold bg-light text-end">
                                    {window.translate("Cost")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedItems.map((item) => (
                                  <tr key={`${item._id}-${item.quantity}`}>
                                    {console.log(
                                      "🧾 Rendered Order Row:",
                                      item._id,
                                      "| Qty:",
                                      item.quantity,
                                      "| Unit Price: $",
                                      item.Price,
                                      "| Total: $",
                                      (item.Price * item.quantity).toFixed(2)
                                    )}
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <Link
                                          className="delete-icon"
                                          to="#"
                                          onClick={() =>
                                            handleRemoveItem(item._id)
                                          }
                                        >
                                          <i className="ti ti-trash-x-filled" />
                                        </Link>
                                        <h6 className="fs-13 fw-normal">
                                          <Link to="#" className="link-default">
                                            {item.Product_Name || item.name}
                                          </Link>
                                        </h6>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="qty-item m-0">
                                        <td>
                                          <div className="qty-item m-0">
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                border: "1px solid #ccc",
                                                borderRadius: "30px",
                                                overflow: "hidden",
                                                height: "36px",
                                                width: "100px",
                                                backgroundColor: "#fff",
                                              }}
                                            >
                                              <button
                                                onClick={() => {
                                                  if (item.quantity > 1) {
                                                    handleQuantityChange(
                                                      item._id,
                                                      item.quantity - 1
                                                    );
                                                  }
                                                }}
                                                style={{
                                                  width: "32px",
                                                  height: "100%",
                                                  border: "none",
                                                  backgroundColor: "#f0f0f0",
                                                  fontSize: "18px",
                                                  fontWeight: "bold",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                −
                                              </button>
                                              <div
                                                style={{
                                                  flex: 1,
                                                  textAlign: "center",
                                                  fontSize: "16px",
                                                  fontWeight: "500",
                                                  userSelect: "none",
                                                }}
                                              >
                                                {item.quantity}
                                              </div>
                                              <button
                                                onClick={() => {
                                                  handleQuantityChange(
                                                    item._id,
                                                    item.quantity + 1
                                                  );
                                                }}
                                                style={{
                                                  width: "32px",
                                                  height: "100%",
                                                  border: "none",
                                                  backgroundColor: "#f0f0f0",
                                                  fontSize: "18px",
                                                  fontWeight: "bold",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                +
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                      </div>
                                    </td>
                                    <td className="fs-13 fw-semibold text-gray-9 text-end">
                                      {(item.Price * item.quantity).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      {/* <div className="discount-item d-flex align-items-center justify-content-between  bg-purple-transparent mt-3 flex-wrap gap-2">
                        <div className="d-flex align-items-center">
                          <span className="bg-purple discount-icon br-5 flex-shrink-0 me-2">
                            <img
                              src="assets/img/icons/discount-icon.svg"
                              alt="img"
                            />
                          </span>
                          <div>
                            <h6 className="fs-14 fw-bold text-purple mb-1">
                              Discount 5%
                            </h6>
                            <p className="mb-0">
                              For $20 Minimum Purchase, all Items
                            </p>
                            <p></p>
                          </div>
                        </div>
                        <Link to="#" className="close-icon">
                          <i className="ti ti-trash" />
                        </Link>
                      </div> */}
                    </div>
                    <div className="order-total bg-total bg-white p-0">
                      <h5 className="mb-3">
                        {window.translate("Payment Summary")}
                      </h5>
                      {/* <table className="table table-responsive table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              Shipping
                             
                            </td>
                            <td className="text-gray-9 text-end">
                              ${shipping.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Tax
                              
                            </td>
                            <td className="text-gray-9 text-end">
                              ${tax.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Coupon
                              
                            </td>
                            <td className="text-gray-9 text-end">
                              ${coupon.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span className="text-danger">Discount</span>
                             
                            </td>
                            <td className="text-danger text-end">
                              ${discount.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check form-switch">
                                
                                <label
                                  className="form-check-label"
                                  htmlFor="round"
                                >
                                  Roundoff
                                </label>
                              </div>
                            </td>
                            <td className="text-gray-9 text-end">
                              +{roundoff.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td>Sub Total</td>
                            <td className="text-gray-9 text-end">
                              ${subtotal.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-bold border-top border-dashed">
                              Total Payable
                            </td>
                            <td className="text-gray-9 fw-bold text-end border-top border-dashed">
                              ${totalPayable.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table> */}
                      {selectedItems.length > 0 && (
                        <table className="table table-responsive table-borderless">
                          <tbody>
                            {/* <tr>
                              <td>{window.translate("Shipping")}</td>
                              <td className="text-gray-9 text-end">
                                {shipping.toFixed(2)}
                              </td>
                            </tr> */}
                            <tr>
                              <td>{window.translate("Tax")}</td>
                              <td className="text-gray-9 text-end">
                                {tax.toFixed(2)}
                              </td>
                            </tr>
                            {/* <tr>
                              <td>{window.translate("Coupon")}</td>
                              <td className="text-gray-9 text-end">
                                {coupon.toFixed(2)}
                              </td>
                            </tr> */}
                            <tr>
                              <td>
                                <span className="text-danger">
                                  {window.translate("Discount")}
                                </span>
                              </td>
                              <td className="text-danger text-end">
                                {discount.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-switch p-0">
                                  <label
                                    className="form-check-label"
                                    htmlFor="round"
                                  >
                                    {window.translate("Roundoff")}
                                  </label>
                                </div>
                              </td>
                              <td className="text-gray-9 text-end">
                                +{roundoff.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>{window.translate("Sub Total")}</td>
                              <td className="text-gray-9 text-end">
                                {subtotal.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="fw-bold border-top border-dashed">
                                {window.translate("Total Payable")}
                              </td>
                              <td className="text-gray-9 fw-bold text-end border-top border-dashed">
                                {totalPayable.toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card payment-method">
                  <div className="card-body">
                    <h5 className="mb-3">
                      {window.translate("Select Payment")}
                    </h5>
                    <div className="row align-items-center methods g-2">
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#payment-cash"
                        >
                          <img
                            src="assets/img/icons/cash-icon.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">
                            {window.translate("Cash")}
                          </p>
                        </Link>
                      </div>
                      {/* <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#payment-card"
                        >
                          <img
                            src="assets/img/icons/card.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Card</p>
                        </Link>
                      </div> */}

                      {/* <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#payment-points"
                        >
                          <img
                            src="assets/img/icons/points.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Points</p>
                        </Link>
                      </div>
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#payment-deposit"
                        >
                          <img
                            src="assets/img/icons/deposit.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Deposit</p>
                        </Link>
                      </div>
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#payment-cheque"
                        >
                          <img
                            src="assets/img/icons/cheque.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Cheque</p>
                        </Link>
                      </div>
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#gift-payment"
                        >
                          <img
                            src="assets/img/icons/giftcard.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Gift Card</p>
                        </Link>
                      </div>
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#scan-payment"
                        >
                          <img
                            src="assets/img/icons/scan-icon.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Scan</p>
                        </Link>
                      </div>
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                        >
                          <img
                            src="assets/img/icons/paylater.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Pay Later</p>
                        </Link>
                      </div>
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                        >
                          <img
                            src="assets/img/icons/external.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">External</p>
                        </Link>
                      </div>
                      <div className="col-sm-6 col-md-4 d-flex">
                        <Link
                          to="#"
                          className="payment-item d-flex align-items-center justify-content-center p-2 flex-fill"
                          data-bs-toggle="modal"
                          data-bs-target="#split-payment"
                        >
                          <img
                            src="assets/img/icons/split-bill.svg"
                            className="me-2"
                            alt="img"
                          />
                          <p className="fs-14 fw-medium">Split Bill</p>
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className="btn-row d-flex align-items-center justify-content-between gap-3">
                  <div className="d-flex align-items-center flex-fill gap-2">
                    <select
                      className="form-select pd-3"
                      style={{
                        maxWidth: 150,
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                      value={invoiceLang}
                      onChange={(e) => setInvoiceLang(e.target.value)}
                    >
                      <option value="en">
                        {window.translate("English Invoice")}
                      </option>
                      <option value="ar">
                        {window.translate("Arabic Invoice")}
                      </option>
                    </select>

                    <button
                      type="button"
                      className="btn btn-white d-flex align-items-center justify-content-center flex-fill m-0"
                      onClick={() => printInvoice(invoiceLang)}
                      title={window.translate("Print last successful invoice")}
                    >
                      <i className="ti ti-printer me-2 ms-2" />
                      {window.translate("Print Order")}
                    </button>
                  </div>

                  <Link
                    to="#"
                    className="btn btn-secondary d-flex align-items-center justify-content-center flex-fill m-0"
                    onClick={handlePlaceOrder}
                  >
                    <i className="ti ti-shopping-cart me-2 ms-2" />
                    {window.translate("Place Order")}
                  </Link>
                </div>
              </aside>
            </div>
            {/* /Order Details */}
          </div>
          {/* <div className="pos-footer bg-white p-3 border-top">
            <div className="d-flex align-items-center justify-content-center flex-wrap gap-2">
              <Link
                to="#"
                className="btn btn-orange d-inline-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#hold-order"
              >
                <i className="ti ti-player-pause me-2" />
                Hold
              </Link>
              <Link
                to="#"
                className="btn btn-info d-inline-flex align-items-center justify-content-center"
              >
                <i className="ti ti-trash me-2" />
                Void
              </Link>
              <Link
                to="#"
                className="btn btn-cyan d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#payment-completed"
              >
                <i className="ti ti-cash-banknote me-2" />
                Payment
              </Link>
              <Link
                to="#"
                className="btn btn-secondary d-inline-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#orders"
              >
                <i className="ti ti-shopping-cart me-2" />
                View Orders
              </Link>
              <Link
                to="#"
                className="btn btn-indigo d-inline-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#reset"
              >
                <i className="ti ti-reload me-2" />
                Reset
              </Link>
              <Link
                to="#"
                className="btn btn-danger d-inline-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#recents"
              >
                <i className="ti ti-refresh-dot me-2" />
                Transaction
              </Link>
            </div>
          </div> */}
        </div>
      </div>
      <PosModals
        selectedItems={selectedItems}
        totalAmount={totalPayable}
        receivedAmount={receivedAmount}
        setReceivedAmount={setReceivedAmount}
        payingAmount={payingAmount}
        setPayingAmount={setPayingAmount}
        change={change}
        setChange={setChange}
        paymentType={paymentType}
        setPaymentType={setPaymentType}
        paymentReceiver={paymentReceiver}
        setPaymentReceiver={setPaymentReceiver}
        paymentNote={paymentNote}
        setPaymentNote={setPaymentNote}
        saleNote={saleNote}
        setSaleNote={setSaleNote}
        staffNote={staffNote}
        setStaffNote={setStaffNote}
        // customerId={customerId} // ✅ ADD THIS
        handlePlaceOrder={handlePlaceOrder} // ✅ ADD THIS
      />
    </div>
  );
};

export default Pos;
